module.exports = __webpack_public_path__ + "79d521468610b613a0fd4c9de5e6ed05.pdf";